// vs-comparison 纯 SVG 渲染。复用 tick.vsHighlight 推导高亮 stat。
import type { SceneData } from '../../api/types'
import type { VsData, VsSide } from './types'
import { vsHighlight } from './tick'
import { COLORS, FONT_SANS, esc } from '../../export/svgRender'

export function render(data: SceneData, time: number): string {
  const d = data as unknown as VsData
  const hl = vsHighlight(data, time)
  const left = d.left
  const right = d.right
  if (!left || !right) return ''

  const dividerX = 540
  const nameY = 300
  const statStartY = 480
  const statGap = 180

  const renderSide = (side: VsSide, originX: number): string => {
    const parts: string[] = []
    parts.push(`  <text x="${originX}" y="${nameY}" font-size="48" font-weight="700" fill="${COLORS.w}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(side.name)}</text>`)
    ;(side.stats || []).forEach((s, i) => {
      const y = statStartY + i * statGap
      const active = i === hl
      if (active) {
        parts.push(`  <rect x="${originX - 240}" y="${y - 55}" width="480" height="110" rx="16" ry="16" fill="${COLORS.pSubtle}"/>`)
      }
      parts.push(`  <text x="${originX}" y="${y - 18}" font-size="56" font-weight="700" fill="${active ? COLORS.pHover : COLORS.w}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(s.value)}</text>`)
      parts.push(`  <text x="${originX}" y="${y + 32}" font-size="36" font-weight="400" fill="${active ? COLORS.t : COLORS.t3}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(s.label)}</text>`)
    })
    return parts.join('\n')
  }

  return `
  <defs><linearGradient id="vsdiv" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${COLORS.w}" stop-opacity="0"/><stop offset="0.5" stop-color="${COLORS.w}" stop-opacity="0.15"/><stop offset="1" stop-color="${COLORS.w}" stop-opacity="0"/></linearGradient></defs>
  <rect x="${dividerX - 1}" y="288" width="2" height="1344" fill="url(#vsdiv)"/>
  <circle cx="${dividerX}" cy="960" r="68" fill="${COLORS.bg}"/>
  <circle cx="${dividerX}" cy="960" r="60" fill="${COLORS.p}"/>
  <text x="${dividerX}" y="960" font-size="42" font-weight="800" fill="#fff" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">VS</text>
${renderSide(left, 270)}
${renderSide(right, 810)}`
}
